__turbopack_context__.v({
  "map": "AsiaMap-module-scss-module__77FLlG__map",
});
